import {Component, Input, OnInit} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {AdditionalUserVetcode} from "../../models/additional-user-vetcode.model";

@Component({
  selector: 'app-addition-user-vetcodes-details',
  templateUrl: './addition-user-vetcodes-details.component.html',
  styleUrls: ['./addition-user-vetcodes-details.component.scss'],
})
export class AdditionUserVetcodesDetailsComponent implements OnInit {

  @Input() title;
  status: string;
  settlementStatus: any;
  @Input()
  additionalUserVetcodes: AdditionalUserVetcode[];


  constructor(public commonUtils: CommonUtils,
              private modalController: ModalController) {

  }

  ngOnInit() {

  }


  onClose() {
    this.modalController.dismiss();
  }

}




